<router-outlet></router-outlet>
<ngx-spinner bdOpacity="0.8" bdColor="#000" size="medium" color="#fff" type="pacman">
  <p id="system-loading">System is in progress</p>
</ngx-spinner>
